module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="navbar-header">\n    <!-- Collapsed Window Nav -->\n    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#topbar-navi">\n        <span class="sr-only">' +
((__t = ( strings.topbar.toggle )) == null ? '' : __t) +
'</span>\n        <span class="icon-bar"></span>\n        <span class="icon-bar"></span>\n        <span class="icon-bar"></span>\n    </button>\n    <div class="merchant-nav2">\n        <div class="parent-unit">\n            ' +
((__t = ( data.activeMerchantInfoCont )) == null ? '' : __t) +
'\n        </div>\n        <div id="businessUnitSelector"></div>\n    </div>\n</div>\n\n<div class="collapse navbar-collapse" id="topbar-navi">\n    <ul class="utility-nav nav navbar-nav navbar-right">\n        <li class="package-info"></li>\n        <li class="icon-menu"></li>\n        <li class="currency-selector"></li>\n        <li class="user-nav dropdown clearfix">\n            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">\n                <span class="greeting">' +
((__t = ( strings.topbar.hi )) == null ? '' : __t) +
' <span class="username">' +
__e( data.displayName ) +
'</span> &nbsp;<i class="far fa-angle-down"></i></span>\n            </a>\n            <ul class="dropdown-menu" role="menu">\n                ';
 if (data.isAdminApp) { ;
__p += '\n                <li class="sign-out">\n                    <div class="sign-out-inner">\n                        ';
 if (data.isGettingMimicked) { ;
__p += '\n                        <a href="#" class="stopMimic btn btn-default">' +
((__t = ( strings.topbar.menu.stop_mimicking )) == null ? '' : __t) +
'</a>\n                        ';
 } ;
__p += '\n                        <a href="' +
((__t = ( data.logoutPage )) == null ? '' : __t) +
'" class="logout btn btn-default">' +
((__t = ( strings.topbar.menu.sign_out )) == null ? '' : __t) +
'</a>\n                    </div>\n                </li>\n                <li class="extra-feature">\n                    <a target="_blank" href="/merchant">Merchant portal</a>\n                </li>\n                ';
 } else { ;
__p += '\n                <li><span class="header">Your account</span><span class="close"><i class="fal fa-times"></i></span></li>\n                <li class="section-header">User settings</li>\n                <li><a href="#" data-fragment="preferences/profile" class="profile gotofragment">Profile</a></li>\n                <li><a href="#" data-fragment="preferences/preferences" class="profile gotofragment">Preferences</a></li>\n                ';
 if (data.sso_user === false) { ;
__p += '\n                <li><a href="#" data-fragment="preferences/security" class="sign-in gotofragment">Change password</a></li>\n                ';
 } ;
__p += '\n                ';
 if (data.hasAlerts2) { ;
__p += '\n                <li><a href="#" data-fragment="alerts2/inbox" class="alerts2 gotofragment">Alerts</a></li>\n                ';
 } ;
__p += '\n                ';
 if (data.canAddUsers) { ;
__p += '\n                <li class="section-header">Admin tools</li>\n                <li><a href="#" data-fragment="preferences/users" class="users gotofragment">' +
((__t = ( strings.userManagement )) == null ? '' : __t) +
'</a></li>\n                ';
 } ;
__p += '\n                ';
 if (data.hasBUManager) { ;
__p += '\n                <li><a href="#" data-fragment="preferences/bumanager" class="data gotofragment">' +
((__t = ( strings.preferences.bu_hierarchy.title )) == null ? '' : __t) +
'</a></li>\n                ';
 } ;
__p += '\n                ';
 if (data.canSeeDataStatus) { ;
__p += '\n                <li><a href="#" data-fragment="preferences/data" class="data gotofragment">Data status</a></li>\n                ';
 } ;
__p += '\n                <li class="sign-out">\n                    <div class="sign-out-inner">\n                        ';
 if (data.isGettingMimicked) { ;
__p += '\n                        <a href="#" class="stopMimic btn btn-default">' +
((__t = ( strings.topbar.menu.stop_mimicking )) == null ? '' : __t) +
'</a>\n                        ';
 } ;
__p += '\n                        <a href="' +
((__t = ( data.logoutPage )) == null ? '' : __t) +
'" class="logout btn btn-default">' +
((__t = ( strings.topbar.menu.sign_out )) == null ? '' : __t) +
'</a>\n                    </div>\n                </li>\n                ';
 if (data.select_merchant) { ;
__p += '\n                <li class="extra-feature">\n                    <a href="#" class="select-merchant">Switch merchant<div class="key-combo">Alt+M</div>\n                    </a>\n                </li>\n                ';
 } ;
__p += '\n                ';
 if (data.superuser) { ;
__p += '\n                <li class="extra-feature">\n                    <a target="_blank" href="/merchant/administrator">Pazien admin portal</a>\n                </li>\n                ';
 } ;
__p += '\n                ';
 } ;
__p += '\n            </ul>\n        </li>\n    </ul>\n</div>\n';
return __p
}